<script setup lang="ts">
import type {PropType} from "vue";
import type {AddressErrors} from "~/types/addressTypes";
import InputAddress from "~/components/component/Service/order/forms/address/InputAddress.vue";

const props = defineProps({
  errors: {
    type: Object as PropType<AddressErrors>,
    default: {
      city: {
        isError:false ,
        text: ''
      },
      street: {
        isError:false ,
        text: ''
      },
      house: {
        isError:false ,
        text: ''
      },
    }
  },
  showSaveButton: {
    type: Boolean,
    default: true
  },
  showBackButton: {
    type: Boolean,
    default: true
  }
})

const editAddress = defineModel()
const route = useRoute()
const isBccPage = computed(() => route.name === 'bcc')

const emit = defineEmits(['back', 'update'])

function handleBack() {
  emit('back')
}
function handleUpdate() {
  emit('update',editAddress.value)
}
</script>

<template>
  <div>
    <InputAddress v-model="editAddress" :errors="errors" :key="errors"/>
    <div v-if="isBccPage && (showBackButton || showSaveButton)" class="flex gap-3 items-center mt-5">
      <button
          v-if="showBackButton"
          type="button"
          @click="handleBack"
          class="flex-1 h-[50px] rounded-2xl border-[1.5px] border-[#E8EAE8] bg-white text-[#2c3530] text-[14px] font-bold"
      >{{ $t('input_forms.button.back') }}</button>
      <button
          v-if="showSaveButton"
          type="button"
          @click="handleUpdate"
          class="flex-1 h-[50px] rounded-2xl bg-primary-green text-white text-[14px] font-bold"
      >{{ $t('input_forms.button.save') }}</button>
    </div>
    <div v-else class="flex md:flex-row flex-col gap-3 items-center mt-5">
      <UIBtn v-if="showBackButton" :color="'light-gray'" class="rounded-full md:w-fit w-full" @click="handleBack">{{
          $t('input_forms.button.back')
        }}
      </UIBtn>
      <UIBtn v-if="showSaveButton" @click="handleUpdate" :color="'green'" class="rounded-full md:w-fit w-full">{{
          $t('input_forms.button.save')
        }}
      </UIBtn>
    </div>
  </div>
</template>

<style scoped>

</style>